import { create } from 'zustand';
import { ILesson } from '../models/lesson';
import { splitContentList } from '../utils/contentHelper';

interface LessonState {
  lesson: ILesson | null;
  allLessons: any;
  nextLink: string | null;
  previousLink: string | null;
  currentLessonIndex: number;
  setLesson: (lessons: ILesson) => void;
  setAllLessons: (data: any) => void;
  setNextAndPreviousLesson: (baseLink: string) => void;
  setReview: (review: 'like' | 'dislike' | undefined) => void;
  setFavorite: () => void;
  resetLessonContent: () => void;
}

export const useLessonContentStore = create<LessonState>((set, get) => ({
  lesson: null,
  allLessons: [],
  nextLink: null,
  previousLink: null,
  currentLessonIndex: 0,
  setLesson: (lesson: ILesson) => {
    const allLessons = get().allLessons;

    const list = splitContentList(allLessons);
    const currentLessonIndex = list.findIndex(
      (wb: { slug: any }) => wb.slug === lesson?.slug
    );

    set({
      lesson: lesson,
      currentLessonIndex,
    });
  },
  setAllLessons: (data: any) => {
    const currentLesson = get().lesson;
    const list = splitContentList(data);
    const currentLessonIndex = list.findIndex(
      (wb: { slug: any }) => wb.slug === currentLesson?.slug
    );

    set({
      allLessons: data,
      currentLessonIndex,
    });
  },
  setReview: (review: 'like' | 'dislike' | undefined) => {
    const currentLesson = get().lesson;
    if (currentLesson) {
      set({
        lesson: {
          ...currentLesson,
          review: review,
        },
      });
    }
  },
  setFavorite: () => {
    const currentLesson = get().lesson;
    if (currentLesson) {
      set({
        lesson: {
          ...currentLesson,
          favorite: !currentLesson.favorite,
        },
      });
    }
  },
  setNextAndPreviousLesson: (baseLink: string) => {
    const currentLesson = get().lesson;
    const allContents = get().allLessons;

    const list = splitContentList(allContents);
    const currentLessonIndex = list.findIndex(
      (wb: { slug: any }) => wb.slug === currentLesson?.slug
    );

    let nextLink: string | null = null;
    let previousLink: string | null = null;

    if (
      currentLessonIndex !== -1 &&
      currentLessonIndex < list.length - 1
    ) {
      const nextIndex = currentLessonIndex + 1;
      nextLink = `${baseLink}/${list[nextIndex].slug}`;
    }

    if (currentLessonIndex > 0) {
      const previousIndex = currentLessonIndex - 1;
      previousLink = `${baseLink}/${list[previousIndex].slug}`;
    }

    set({ nextLink, previousLink });
  },
  resetLessonContent: () =>
    set({
      lesson: null,
      allLessons: [],
      nextLink: null,
      previousLink: null,
      currentLessonIndex: 0,
    }),
}));
